import { type CSSProperties, type HTMLProps } from 'react';

type ParagraphProps = HTMLProps<HTMLDivElement> & {
  style?: CSSProperties;
  isLast?: boolean;
};

export function Paragraph({
  style,
  isLast,
  children,
  ...props
}: ParagraphProps) {
  return (
    <div
      {...props}
      style={{
        ...(!isLast && { marginBottom: 15 }),
        lineHeight: '1.5em',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
